/* Gentle Beauty — product page & quick view controller (variants, price, stock, cart, sticky bar, delivery, share).
   Works on [data-gb-product] roots (sections/gb-main-product.liquid, sections/gb-quick-view.liquid). No dependencies. */
(function () {
  'use strict';
  if (window.GBProduct) return;

  var money = function (cents) {
    return window.GB && GB.formatMoney ? GB.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var cartAddUrl = function () { return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js'; };
  var cartUrl = function () { return (window.routes && window.routes.cart_url) || '/cart'; };

  /* ------------------------------------------------------------------ */
  function Product(root) {
    this.root = root;
    this.quick = root.hasAttribute('data-gb-quick');
    var json = $('[data-gb-product-json]', root);
    try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = { variants: [] }; }
    this.form = $('form[data-gb-product-form]', root);
    this.variant = this.currentVariantFromInputs() || this.findById(this.idValue()) || this.data.variants[0];
    this.bind();
    this.initSticky();
    this.initDelivery();
    this.initReadMore();
    this.initShades();
    this.initFreeShipping();
    this.initMiniGallery();
    this.syncGuideRows();
    root.setAttribute('data-gb-init', '');
  }

  Product.prototype.idValue = function () {
    var input = $('input[name="id"][data-gb-variant-id]', this.root);
    return input ? Number(input.value) : null;
  };
  Product.prototype.findById = function (id) {
    return (this.data.variants || []).filter(function (v) { return v.id === Number(id); })[0] || null;
  };
  Product.prototype.optionGroups = function () {
    return $$('[data-gb-option]', this.root).sort(function (a, b) { return a.dataset.index - b.dataset.index; });
  };
  Product.prototype.selectedValues = function () {
    return this.optionGroups().map(function (group) {
      var select = $('select[data-gb-option-input]', group);
      if (select) return select.value;
      var checked = $('input[data-gb-option-input]:checked', group);
      return checked ? checked.value : null;
    });
  };
  Product.prototype.currentVariantFromInputs = function () {
    if (this.data.singleVariant || !this.optionGroups().length) return null;
    return this.match(this.selectedValues());
  };
  Product.prototype.match = function (values) {
    return (this.data.variants || []).filter(function (v) {
      return v.options.every(function (o, i) { return values[i] == null || o === values[i]; });
    })[0] || null;
  };

  Product.prototype.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-gb-option-input]');
      if (input) return self.onOptionChange(input);
      if (e.target.matches('[data-gb-sticky-variant]')) return self.selectVariantById(e.target.value);
      if (e.target.matches('[data-gb-pair]')) return self.updateButtonPrice();
      if (e.target.matches('input[name="quantity"]')) { self.clampQty(e.target); self.updateButtonPrice(); }
    });

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-gb-qty-minus]'), plus = e.target.closest('[data-gb-qty-plus]');
      if (minus || plus) {
        var input = $('input', (minus || plus).closest('[data-gb-qty]'));
        if (!input) return;
        var step = Number(input.step) || 1, val = Number(input.value) || 0;
        input.value = val + (plus ? step : -step);
        self.clampQty(input);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var stickyNotify = e.target.closest('[data-gb-atc-sticky][data-mode="notify"]');
      if (stickyNotify) {
        e.preventDefault();
        var notify = $('[data-gb-notify]:not([hidden])', root);
        if (notify) {
          notify.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var email = $('input[type="email"]', notify);
          setTimeout(function () { email && email.focus({ preventScroll: true }); notify.classList.add('is-highlight'); setTimeout(function () { notify.classList.remove('is-highlight'); }, 1600); }, 450);
        }
        return;
      }
      var share = e.target.closest('[data-gb-share]');
      if (share) { e.preventDefault(); return self.share(share); }
      var scroll = e.target.closest('[data-gb-scroll-to]');
      if (scroll) return self.scrollToReviews(e, scroll);
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    }
  };

  Product.prototype.clampQty = function (input) {
    var min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity, step = Number(input.step) || 1;
    var val = Math.round((Number(input.value) || min) / step) * step;
    input.value = Math.min(max, Math.max(min, val));
  };

  Product.prototype.onOptionChange = function (input) {
    var url = input.tagName === 'SELECT' ? (input.selectedOptions[0] && input.selectedOptions[0].dataset.productUrl) : input.dataset.productUrl;
    if (url && this.data.url && url.split('?')[0] !== this.data.url) {
      // Combined listing: option value belongs to another product.
      if (this.quick && window.GB && GB.quickView) return GB.quickView(url);
      window.location.href = url;
      return;
    }
    var values = this.selectedValues();
    var exact = (this.data.variants || []).filter(function (v) {
      return v.options.every(function (o, i) { return o === values[i]; });
    })[0] || null;
    this.setVariant(exact);
  };

  Product.prototype.selectVariantById = function (id) {
    var v = this.findById(id);
    if (!v) return;
    this.optionGroups().forEach(function (group, i) {
      var select = $('select[data-gb-option-input]', group);
      if (select) { select.value = v.options[i]; return; }
      $$('input[data-gb-option-input]', group).forEach(function (r) { r.checked = r.value === v.options[i]; });
    });
    this.setVariant(v);
  };

  Product.prototype.setVariant = function (v) {
    var root = this.root, self = this;
    this.variant = v;

    $$('input[name="id"][data-gb-variant-id]', root).forEach(function (input) {
      input.value = v ? v.id : '';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Selected value labels + availability of other values
    var values = this.selectedValues();
    this.optionGroups().forEach(function (group, i) {
      var label = $('[data-gb-selected-value]', group);
      if (label) label.textContent = values[i] || '';
      $$('input[data-gb-option-input], select[data-gb-option-input] option', group).forEach(function (el) {
        var test = values.slice(); test[i] = el.value;
        var any = self.data.variants.filter(function (variant) {
          return variant.options.every(function (o, j) { return o === test[j]; });
        })[0];
        var available = !!(any && any.available);
        if (el.tagName === 'OPTION') {
          el.textContent = el.value + (available ? '' : ' – ' + (root.dataset.strSoldout || ''));
        } else {
          var lab = root.querySelector('label[for="' + el.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !available);
        }
      });
    });

    this.updatePrice(v);
    this.updateButtons(v);
    this.updateNotify(v);
    this.updateInventory(v);
    this.updateQtyRules(v);
    this.syncGuideRows();

    var sku = $('[data-gb-sku]', root);
    if (sku) { sku.textContent = v && v.sku ? v.sku : ''; sku.parentElement.hidden = !(v && v.sku); }

    var sticky = $('[data-gb-sticky-variant]', root);
    if (sticky && v) sticky.value = v.id;

    var pickup = $('pickup-availability', root);
    if (pickup && typeof pickup.update === 'function' && v) pickup.update(v);

    if (v && !this.quick && root.dataset.updateUrl === 'true' && this.data.url) {
      window.history.replaceState({}, '', this.data.url + '?variant=' + v.id);
    }
    if (v && v.media) {
      root.dispatchEvent(new CustomEvent('gb:variant:media', { bubbles: false, detail: { mediaId: v.media, variant: v, product: this.data } }));
      this.miniGalleryTo && this.miniGalleryTo(v.media);
    }
    document.dispatchEvent(new CustomEvent('gb:variant:change', { detail: { variant: v, product: this.data, root: root } }));
  };

  Product.prototype.updatePrice = function (v) {
    $$('[data-gb-price]', this.root).forEach(function (el) {
      el.hidden = !v;
      if (!v) return;
      var onSale = v.compare > v.price;
      el.classList.toggle('is-on-sale', onSale);
      var cur = $('[data-gb-price-current]', el), cmp = $('[data-gb-price-compare]', el), save = $('[data-gb-price-save]', el), unit = $('[data-gb-price-unit]', el);
      if (cur) cur.textContent = money(v.price);
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? money(v.compare) : ''; }
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((v.compare - v.price) * 100) / v.compare) + '%';
          save.textContent = (el.dataset.saveFormat || 'Save [percent]').replace('[percent]', pct).replace('[amount]', money(v.compare - v.price));
        }
      }
      if (unit) {
        unit.hidden = !v.unit;
        if (v.unit) unit.textContent = money(v.unit) + '/' + (v.unitRef && v.unitRef !== 1 ? v.unitRef : '') + (v.unitRefUnit || '');
      }
    });
    this.updateButtonPrice();
  };

  Product.prototype.updateButtonPrice = function () {
    var v = this.variant; if (!v) return;
    var qtyInput = this.form ? (this.form.querySelector('[name="quantity"]') || $('input[name="quantity"][form="' + this.form.id + '"]')) : null;
    var qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
    var total = v.price * qty;
    $$('[data-gb-pair]:checked', this.root).forEach(function (cb) { total += Number(cb.dataset.price) || 0; });
    $$('[data-gb-atc-price]', this.root).forEach(function (el) { el.textContent = money(total); });
  };

  Product.prototype.updateButtons = function (v) {
    var root = this.root, hasNotify = !!$('[data-gb-notify]', root);
    $$('[data-gb-atc]', root).forEach(function (btn) {
      var label = $('[data-gb-atc-label]', btn);
      var available = !!(v && v.available);
      if (btn.hasAttribute('data-gb-atc-sticky') && hasNotify && v && !available) {
        btn.disabled = false;
        btn.setAttribute('data-mode', 'notify');
        if (label) label.textContent = btn.dataset.notifyLabel || root.dataset.strSoldout;
        return;
      }
      btn.removeAttribute('data-mode');
      btn.disabled = !available;
      if (label) label.textContent = !v ? root.dataset.strUnavailable : (available ? (btn.dataset.addLabel || root.dataset.strAdd) : root.dataset.strSoldout);
    });
  };

  Product.prototype.updateNotify = function (v) {
    var data = this.data;
    $$('[data-gb-notify]', this.root).forEach(function (wrap) {
      wrap.hidden = !v || !!v.available;
      if (!v) return;
      var set = function (sel, val) { var el = $(sel, wrap); if (el) el.value = val; };
      var variantTitle = data.singleVariant ? '' : v.title;
      set('[data-gb-notify-variant]', variantTitle);
      set('[data-gb-notify-variant-id]', v.id);
      var url = $('[data-gb-notify-url]', wrap);
      if (url) url.value = url.dataset.base + '?variant=' + v.id;
      var body = $('[data-gb-notify-body]', wrap);
      if (body) body.value = 'Back in stock request: ' + body.dataset.product + (variantTitle ? ' – ' + variantTitle : '') + ' (variant ' + v.id + ') ' + (url ? url.value : '');
    });
  };

  Product.prototype.updateInventory = function (v) {
    $$('[data-gb-inventory]', this.root).forEach(function (el) {
      var row = $('[data-gb-inventory-state]', el), text = $('[data-gb-inventory-text]', el), bar = $('[data-gb-inventory-bar]', el);
      var threshold = Number(el.dataset.threshold) || 10, max = Number(el.dataset.max) || 30, state = 'in', msg = el.dataset.in, pct = 100;
      if (!v || !v.available) { state = 'out'; msg = el.dataset.out; pct = 0; }
      else if (v.inventory !== null && v.inventory <= 0) { state = 'backorder'; msg = el.dataset.backorder; }
      else if (v.inventory !== null && v.inventory <= threshold) {
        state = 'low'; msg = (el.dataset.low || '').replace('[count]', v.inventory);
        pct = Math.max(6, Math.min(100, Math.round((v.inventory * 100) / max)));
      }
      if (row) {
        row.className = 'gb-stock__row gb-stock--' + state;
        row.setAttribute('data-gb-inventory-state', state);
        row.hidden = state === 'in' && el.dataset.showIn === 'false';
      }
      if (text) text.textContent = msg || '';
      if (bar) { bar.hidden = state !== 'low'; var fill = bar.firstElementChild; if (fill) fill.style.setProperty('--gb-stock', pct + '%'); }
    });
  };

  Product.prototype.updateQtyRules = function (v) {
    if (!v || !this.form) return;
    $$('input[name="quantity"]', this.root).forEach(function (input) {
      input.min = v.qtyMin || 1;
      input.step = v.qtyStep || 1;
      if (v.qtyMax) input.max = v.qtyMax; else input.removeAttribute('max');
      if (Number(input.value) < input.min) input.value = input.min;
    });
  };

  Product.prototype.syncGuideRows = function () {
    var guide = document.querySelector('[data-gb-guide]');
    if (!guide || !this.variant || this.quick) return;
    var values = (this.variant.options || []).map(function (o) { return String(o).toLowerCase(); });
    var rows = $$('[data-gb-guide-row]', guide);
    if (!rows.length || this.data.singleVariant) return;
    rows.forEach(function (row) { row.classList.toggle('is-current', values.indexOf(row.dataset.gbGuideRow) > -1); });
  };

  /* ---------- Add to cart ---------- */
  Product.prototype.onSubmit = function (e) {
    e.preventDefault();
    var v = this.variant, self = this;
    if (!v || !v.available) return;
    var form = this.form, fd = new FormData(form);
    var errorEl = $('[data-gb-form-error]', this.root);
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var main = { id: v.id, quantity: Number(fd.get('quantity')) || 1 };
    var props = {};
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
    });
    if (Object.keys(props).length) main.properties = props;
    if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));

    var items = [main];
    $$('[data-gb-pair]:checked', this.root).forEach(function (cb) { items.push({ id: Number(cb.value), quantity: 1 }); });

    var hasFile = !!form.querySelector('input[type="file"]');
    this.add(items, hasFile ? fd : null, errorEl);
  };

  Product.prototype.add = function (items, formData, errorEl) {
    var self = this, root = this.root;
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var sections = [];
    if (drawer) sections = ['cart-drawer', 'cart-icon-bubble'];
    else if (notification) sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    if (root.dataset.cartType === 'page') sections = [];

    var buttons = $$('[data-gb-atc]', root);
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });

    var request;
    if (formData) {
      if (sections.length) { formData.append('sections', sections.join(',')); formData.append('sections_url', window.location.pathname); }
      request = fetch(cartAddUrl(), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
    } else {
      var body = { items: items };
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
      request = fetch(cartAddUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }

    var linesEvent = this.dispatchLinesEvent(items);

    request
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          var msg = res.description || res.message || (window.cartStrings && window.cartStrings.error) || '';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else if (window.GB && GB.toast) GB.toast(msg);
          linesEvent && linesEvent.reject(new Error(msg));
          return;
        }
        self.resolveLinesEvent(linesEvent);
        if (!sections.length) { window.location.href = cartUrl(); return; }
        if (self.quick && window.GB && GB.closeDrawer) GB.closeDrawer('GBQuickView');
        var first = res.items ? res.items[0] : res;
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          res.id = first && first.id;
          drawer.renderContents(res);
        } else if (notification && typeof notification.renderContents === 'function') {
          var payload = Object.assign({}, first, { sections: res.sections });
          notification.renderContents(payload);
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gb-product', productVariantId: first && first.variant_id, cartData: res });
        }
        document.dispatchEvent(new CustomEvent('gb:cart:added', { detail: res }));
        $$('[data-gb-pair]:checked', root).forEach(function (cb) { cb.checked = false; });
        self.updateButtonPrice();
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = (window.cartStrings && window.cartStrings.error) || String(err); errorEl.hidden = false; }
        linesEvent && linesEvent.reject(err);
      })
      .finally(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      });
  };

  Product.prototype.dispatchLinesEvent = function (items) {
    var SE = window.StandardEvents;
    if (!SE || !SE.CartLinesUpdateEvent || !this.form) return null;
    try {
      var deferred = SE.CartLinesUpdateEvent.createPromise();
      this.form.dispatchEvent(new SE.CartLinesUpdateEvent({
        action: 'add', context: this.quick ? 'dialog' : 'product',
        lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
        promise: deferred.promise
      }));
      return deferred;
    } catch (e) { return null; }
  };
  Product.prototype.resolveLinesEvent = function (deferred) {
    if (!deferred) return;
    var SE = window.StandardEvents;
    fetch(cartUrl() + '.json').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.currency) return deferred.reject(new Error('Missing cart'));
      deferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
    }).catch(function (e) { deferred.reject(e); });
  };

  /* ---------- Sticky add to bag ---------- */
  Product.prototype.initSticky = function () {
    var bar = $('[data-gb-sticky-atc]', this.root), main = $('[data-gb-atc-main]', this.root);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var focusables = $$('button, select', bar);
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      focusables.forEach(function (el) { el.tabIndex = show ? 0 : -1; });
      document.documentElement.classList.toggle('gb-sticky-atc-visible', show);
    }, { threshold: 0 });
    io.observe(main);
  };

  /* ---------- Delivery estimate ---------- */
  Product.prototype.initDelivery = function () {
    $$('[data-gb-delivery]', this.root).forEach(function (el) {
      var text = $('[data-gb-delivery-text]', el);
      if (!text) return;
      var min = Number(el.dataset.min) || 0, max = Math.max(min, Number(el.dataset.max) || min);
      var cutoff = Number(el.dataset.cutoff), skip = el.dataset.skipWeekends === 'true';
      var fmt;
      try { fmt = new Intl.DateTimeFormat(el.dataset.locale || undefined, { weekday: 'short', month: 'short', day: 'numeric' }); }
      catch (e) { fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); }
      var isBusiness = function (d) { return !skip || (d.getDay() !== 0 && d.getDay() !== 6); };
      var addDays = function (date, n) {
        var d = new Date(date.getTime()), added = 0;
        while (added < n) { d.setDate(d.getDate() + 1); if (isBusiness(d)) added++; }
        return d;
      };
      var render = function () {
        var now = new Date(), base = new Date(now.getTime());
        var cut = new Date(now.getTime()); cut.setHours(cutoff >= 0 ? cutoff : 0, 0, 0, 0);
        var before = cutoff >= 0 && now < cut && isBusiness(now);
        if (!before && (cutoff >= 0 || !isBusiness(now))) base = addDays(now, 1);
        if (!isBusiness(base)) base = addDays(base, 1);
        var start = min > 0 ? addDays(base, min) : base, end = addDays(base, max);
        var tpl = before ? el.dataset.template : el.dataset.templateAfter;
        if (!tpl) return;
        var diff = Math.max(0, cut - now), h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
        var countdown = (h ? h + 'h ' : '') + m + 'm';
        text.innerHTML = escapeHtml(tpl)
          .replace('[countdown]', '<strong class="gb-delivery__countdown">' + countdown + '</strong>')
          .replace('[start]', '<strong>' + escapeHtml(fmt.format(start)) + '</strong>')
          .replace('[end]', '<strong>' + escapeHtml(fmt.format(end)) + '</strong>');
      };
      render();
      setInterval(render, 30000);
    });
  };

  /* ---------- Description read more ---------- */
  Product.prototype.initReadMore = function () {
    $$('[data-gb-readmore]', this.root).forEach(function (wrap) {
      var body = $('[data-gb-readmore-body]', wrap), btn = $('[data-gb-readmore-toggle]', wrap);
      if (!body || !btn) return;
      var check = function () {
        wrap.classList.add('is-collapsed');
        var overflow = body.scrollHeight > body.clientHeight + 4;
        btn.hidden = !overflow;
        if (!overflow) wrap.classList.remove('is-collapsed');
      };
      check();
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        wrap.classList.toggle('is-collapsed', !open);
        btn.setAttribute('aria-expanded', open);
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
  };

  /* ---------- Sibling shade swatches: preview name on hover ---------- */
  Product.prototype.initShades = function () {
    $$('[data-gb-shades]', this.root).forEach(function (wrap) {
      var label = $('[data-gb-shade-label]', wrap);
      if (!label) return;
      var reset = function () { label.textContent = label.dataset.default; };
      wrap.addEventListener('mouseover', function (e) { var a = e.target.closest('[data-gb-shade-name]'); if (a) label.textContent = a.dataset.gbShadeName; });
      wrap.addEventListener('focusin', function (e) { var a = e.target.closest('[data-gb-shade-name]'); if (a) label.textContent = a.dataset.gbShadeName; });
      wrap.addEventListener('mouseleave', reset);
      wrap.addEventListener('focusout', reset);
    });
  };

  /* ---------- Free shipping progress on product page (live cart total) ---------- */
  Product.prototype.initFreeShipping = function () {
    var bars = $$('[data-gb-free-ship]', this.root);
    if (!bars.length) return;
    var refresh = function () {
      fetch(cartUrl() + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        bars.forEach(function (el) { GBProduct.renderShipping(el, cart.total_price); });
      }).catch(function () {});
    };
    document.addEventListener('gb:cart:added', refresh);
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
  };

  /* ---------- Quick view mini gallery ---------- */
  Product.prototype.initMiniGallery = function () {
    var gal = $('[data-gb-mini-gallery]', this.root);
    if (!gal) return;
    var track = $('[data-gb-mini-track]', gal), dots = $$('[data-gb-mini-dot]', gal);
    var prev = $('[data-gb-mini-prev]', gal), next = $('[data-gb-mini-next]', gal);
    if (!track) return;
    var slides = $$('[data-gb-mini-slide]', track);
    var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    var update = function () {
      var i = current();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); d.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    prev && prev.addEventListener('click', function () { go(current() - 1); });
    next && next.addEventListener('click', function () { go(current() + 1); });
    this.miniGalleryTo = function (mediaId) {
      slides.forEach(function (s, i) { if (Number(s.dataset.mediaId) === Number(mediaId)) go(i); });
    };
    update();
  };

  /* ---------- Share ---------- */
  Product.prototype.share = function (btn) {
    var url = btn.dataset.url || window.location.href, title = btn.dataset.title || document.title;
    if (this.variant && !this.data.singleVariant) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + this.variant.id;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    var done = function () { window.GB && GB.toast ? GB.toast(btn.dataset.copied || url) : null; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done).catch(function () {});
    else { var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (e) {} ta.remove(); }
  };

  Product.prototype.scrollToReviews = function (e, link) {
    var sel = link.dataset.gbScrollTo, target = null;
    try { target = sel ? document.querySelector(sel) : null; } catch (err) { target = null; }
    if (!target) target = document.querySelector('[data-gb-reviews], #shopify-product-reviews, #judgeme_product_reviews, .jdgm-review-widget, #looxReviews, .yotpo-main-widget, [id*="review"], [id*="Review"]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };


  /* ---------- Back-in-stock notify form (AJAX contact form) ---------- */
  if (!window.__gbNotify) {
    window.__gbNotify = true;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-gb-notify-form]');
      if (!form || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var wrap = form.closest('[data-gb-notify]');
      var status = form.querySelector('[data-gb-notify-status]');
      var btn = form.querySelector('[data-gb-notify-submit]');
      var fields = form.querySelector('[data-gb-notify-fields]');
      var show = function (msg, ok) {
        if (!status) return;
        status.hidden = false;
        status.textContent = msg;
        status.className = 'gb-notify__status gb-notify__status--' + (ok ? 'success' : 'error');
        status.setAttribute('role', ok ? 'status' : 'alert');
      };
      if (btn) btn.classList.add('is-loading');
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (/challenge/.test(r.url)) { form.removeAttribute('data-gb-notify-form'); form.submit(); return null; }
          return r.text().then(function (html) { return { url: r.url, html: html }; });
        })
        .then(function (res) {
          if (!res) return;
          var ok = /contact_posted=true/.test(res.url) || /posted_successfully|form-status--success|contact_posted=true/.test(res.html);
          var hasErrors = /class="[^"]*errors/.test(res.html) && !/contact_posted=true/.test(res.url);
          if (ok && !hasErrors) {
            if (fields) fields.hidden = true;
            show(wrap ? wrap.dataset.success : '', true);
            wrap && wrap.classList.add('is-success');
          } else {
            show(wrap ? wrap.dataset.error : '', false);
          }
        })
        .catch(function () { show(wrap ? wrap.dataset.error : '', false); })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    });
  }

  /* ------------------------------------------------------------------ */
  var GBProduct = (window.GBProduct = {
    Product: Product,
    init: function (scope) {
      $$('[data-gb-product]:not([data-gb-init])', scope || document).forEach(function (root) {
        try { root.__gbProduct = new Product(root); } catch (err) { if (window.console) console.error(err); }
      });
    },
    renderShipping: function (el, total) {
      var threshold = Number(el.dataset.threshold) || 0;
      if (!threshold) return;
      var remaining = Math.max(0, threshold - total), pct = Math.min(100, Math.round((total * 100) / threshold));
      var unlocked = remaining <= 0;
      var text = $('[data-gb-ship-text]', el), goal = $('[data-gb-ship-goal]', el), fill = $('[data-gb-ship-fill]', el);
      var wasUnlocked = el.classList.contains('is-unlocked');
      el.classList.toggle('is-unlocked', unlocked);
      if (unlocked && !wasUnlocked) { el.classList.remove('is-celebrating'); void el.offsetWidth; el.classList.add('is-celebrating'); }
      if (text) text.innerHTML = unlocked ? escapeHtml(el.dataset.success) : escapeHtml(el.dataset.progress).replace('[amount]', '<strong>' + escapeHtml(money(remaining)) + '</strong>');
      if (goal && el.dataset.goal === 'remaining') goal.textContent = unlocked ? '✓' : money(remaining) + ' ' + (el.dataset.toGo || '');
      if (fill) fill.style.setProperty('--gb-ship', pct + '%');
      var bar = fill && fill.parentElement; if (bar) bar.setAttribute('aria-valuenow', pct);
    }
  });


  /* ---------- Product story: count-up stats, before/after slider, guide opener ---------- */
  var initStory = function (scope) {
    $$('[data-gb-story]:not([data-gb-init])', scope || document).forEach(function (story) {
      story.setAttribute('data-gb-init', '');
      var counters = $$('[data-gb-count]', story);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animate = function (el) {
        var raw = String(el.dataset.gbCount), target = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (isNaN(target) || reduce) return;
        var decimals = (raw.split('.')[1] || '').length, start = null, dur = 1400;
        var tick = function (ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) window.requestAnimationFrame(tick); else el.textContent = raw;
        };
        el.textContent = (0).toFixed(decimals);
        window.requestAnimationFrame(tick);
      };
      if (counters.length) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); animate(en.target); } });
          }, { threshold: 0.6 });
          counters.forEach(function (c) { io.observe(c); });
        }
      }
      $$('[data-gb-compare]', story).forEach(function (cmp) {
        var range = $('[data-gb-compare-range]', cmp);
        if (!range) return;
        var set = function () { cmp.style.setProperty('--gb-pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      });
      story.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-gb-open-guide]');
        if (!btn) return;
        var guide = document.querySelector(btn.dataset.gbOpenGuide || '[data-gb-guide]');
        if (guide && window.GB && GB.openDrawer) { e.preventDefault(); GB.openDrawer(guide, btn); }
        else if (window.GB && GB.toast) {
          var main = document.querySelector('[data-gb-product]');
          main && main.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  };
  var boot = function () { GBProduct.init(document); initStory(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { GBProduct.init(e.target); initStory(e.target); });
  document.addEventListener('gb:quickview:loaded', function (e) { GBProduct.init((e.detail && e.detail.el) || document); });
})();
